import { DataModel } from './data-model.model';
import { ModuleComplianceV1Read } from './module-compliance-v1-read.model';

export class ModuleSubmissionAdminRead extends DataModel {
    moduleTitle?: string = '';
    summary?: string = '';
    versionNumber?: number;
    repositoryId?: string = '';
    commentToReviewer?: string = '';
    commentToProducer?: string = '';
    producerId?: string = '';
    producerEmail?: string = '';
    producer?: string = '';
    isOpenSource?: boolean = false;
    codeDownloadUrl?: string = '';
    versionImageUrl?: string = '';
    createdAt?: string = '';
    state?: SubmissionState = SubmissionState.inReview;
    testFileUrls?: string[] = [];
    compliances: ModuleComplianceV1Read[] = [];
    moduleId?: string;

    get isCompliant(): boolean {
        return this.compliances && this.compliances.length > 0;
    }
}

enum SubmissionState {
    inReview = 0,
    rejected = 1,
    approved = 2,
}
